module.exports = __webpack_public_path__ + "front/img/5.44630496.png";